export default __webpack_public_path__ + "static/media/ManyFish.7f715a19.png";